import { Component, Input, OnInit } from '@angular/core';
import { Office } from '../../../core/models/office.model';
import { ProviderOffice } from '../../../core/models/provider-office.model';

import { OfficeComponent } from '../office/office.component';

class OfficeDetail {
  constructor(public office: Office, public officeStatus: string, public officeNames: string[]) {}
}

@Component({
    selector: 'app-consult-note-office',
    templateUrl: './consult-note-office.component.html',
    styleUrls: ['./consult-note-office.component.scss'],
    imports: [OfficeComponent]
})
export class ConsultNoteOfficeComponent implements OnInit {
  @Input() providerOffice: ProviderOffice;

  officeDetail: OfficeDetail = null;

  constructor() {}

  ngOnInit() {
    if (this.providerOffice) {
      const officeNames =
        this.providerOffice.office &&
        this.providerOffice.office.officeNames;

      this.officeDetail = new OfficeDetail(
        this.providerOffice.office,
        this.providerOffice.status,
        officeNames || []
      );
    }
  }
}
